<script lang="ts">
  import Container from '$components/News/Container.svelte';
  import { ResponsiveVars, TwistGrid, TwistGridItem } from '@twist/core';
  import { cx } from '@emotion/css';
  import {
    jobsStore,
    fetchedJobsLength,
    hasNextPage,
    jobsByJobFunction
  } from '$lib/stores/Careers/jobsStore';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import { jobsFiltersStore } from '$lib/stores/Careers/jobFiltersStore';
  import BlockButton from '$components/Button/BlockButton.svelte';
  import JobListItem from './JobListItem.svelte';

  const responsiveVars = new ResponsiveVars()
    .addFluid('list-mt', toFluidVarInput(64, 50))
    .addFluid('h3-font-size', toFluidVarInput(24, 36))
    .addFluid('job-function-section-pt', toFluidVarInput(18, 60))
    .addFluid('job-function-section-pb', toFluidVarInput(45, 90))
    .addFluid('job-function-count-font-size', toFluidVarInput(12, 15))
    .addFluid('job-function-count-mt', toFluidVarInput(15, 15))
    .addFluid('job-function-count-mb', toFluidVarInput(45, 0))
    .addFluid('job-stack-spacing', toFluidVarInput(27, 45))
    .addFluid('load-more-gap', toFluidVarInput(12, 12))
    .addFluid('status-text-font-size', toFluidVarInput(12, 15))
    .toCSS();
</script>

<div class={cx(responsiveVars, 'list')}>
  <Container>
    {#each Object.entries($jobsByJobFunction) as [jobFunction, jobs]}
      <div class="job-function-section">
        <TwistGrid>
          <TwistGridItem colSpan={{ min: 4, lg: 6 }} rowStart={1}>
            <h3>{jobFunction}</h3>

            {@const count = $jobsStore.aggregates.jobFunctionCounts[jobFunction]}
            {#if count}
              <p class="job-function-count">
                {count}
                <span>job{count > 1 ? 's' : ''}</span>
              </p>
            {/if}
          </TwistGridItem>

          <TwistGridItem
            colSpan={{ min: 4, lg: 6 }}
            colStart={{ min: 1, lg: 7 }}
            rowStart={{ min: 2, lg: 1 }}
          >
            <div class="jobs-stack">
              {#each jobs as job}
                <JobListItem {job} />
              {/each}
            </div>
          </TwistGridItem>
        </TwistGrid>
      </div>
    {/each}

    {#if $hasNextPage}
      <div class="load-more">
        <BlockButton on:click={() => jobsStore.fetchNextPage($jobsFiltersStore)}>
          Load more
        </BlockButton>
        <p class="load-more-status-text">
          Showing {$fetchedJobsLength} of {$jobsStore.aggregates.total}
        </p>
      </div>
    {/if}
  </Container>
</div>

<style lang="scss">
  .list {
    margin-top: var(--list-mt);
  }

  h3 {
    font-weight: 700;
    font-size: var(--h3-font-size);
    line-height: 115%;
    font-family: var(--font-family-primary);
  }

  .job-function-section {
    border-top: 1px solid black;
    padding-top: var(--job-function-section-pt);
    padding-bottom: var(--job-function-section-pb);
  }

  .job-function-count {
    font-weight: 600;
    line-height: 130%;
    text-transform: uppercase;
    font-size: var(--job-function-count-font-size);
    font-family: var(--font-family-primary);

    margin-top: var(--job-function-count-mt);
    margin-bottom: var(--job-function-count-mb);
  }

  .jobs-stack {
    display: flex;
    flex-direction: column;
    gap: var(--job-stack-spacing);
  }

  .load-more {
    --theme-button-primary-button-default-foreground-color: var(--twist-color-gray-100);
    --theme-button-primary-button-active-foreground-color: var(--twist-color-gray-0);
    --theme-button-primary-button-hover-focus-foreground-color: var(--twist-color-gray-0);
    --theme-button-primary-button-default-background-color: #e2e2e2;
    --theme-button-primary-button-active-background-color: #666666;
    --theme-button-primary-button-hover-focus-background-color: #666666;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: var(--load-more-gap);
  }

  .load-more-status-text {
    font-family: var(--font-family-primary);
    font-size: var(--status-text-font-size);
    line-height: 120%;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
  }
</style>
